import React, { Component } from 'react';
const MyContext = React.createContext();
export default MyContext;